import { Route } from '@angular/router';
import { SecureComponent } from './secure.component';
import {AuthGuard} from '../core/_guards/auth.guards';
import { SpinnerComponent } from '../core/spinner/spinner.component';
import { adminstratorRoutes } from './adminstrator/adminstrator.routes';
import { developerRoutes } from './developer/developer.routes';
export const secureRoutes: Route[] = [
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: SpinnerComponent,
      },
      ...adminstratorRoutes,
      ...developerRoutes,
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];